import { Link } from 'react-router-dom';
import { useT } from '@/i18n/LocaleContext';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';

export function SiteFooter() {
  const t = useT('common');
  const { localizedTo } = useLocalizedNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 bg-vyxora-abyss">
      <div className="container-site grid gap-10 py-16 md:grid-cols-4">
        <div>
          <img
            src="/imagens/logo_principal.png"
            alt="VYXORA"
            className="h-8 w-auto"
          />
          <p className="mt-5 max-w-xs text-sm text-vyxora-text-light/60">
            {t('footer.tagline')}
          </p>
          <a
            href="mailto:contato@vyxora.com.br"
            className="mt-4 inline-block text-sm text-vyxora-cyan-300 hover:text-vyxora-cyan-400"
          >
            contato@vyxora.com.br
          </a>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-widest text-vyxora-cyan-300">
            {t('footer.colProduto')}
          </h4>
          <ul className="space-y-2 text-sm text-vyxora-text-light/70">
            <li>
              <Link to={localizedTo('/plataforma')} className="hover:text-vyxora-cyan-300">
                {t('nav.plataforma')}
              </Link>
            </li>
            <li>
              <Link to={localizedTo('/cases')} className="hover:text-vyxora-cyan-300">
                {t('nav.cases')}
              </Link>
            </li>
            <li>
              <Link to={localizedTo('/futuro')} className="hover:text-vyxora-cyan-300">
                {t('nav.futuro')}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-widest text-vyxora-cyan-300">
            {t('footer.colEmpresa')}
          </h4>
          <ul className="space-y-2 text-sm text-vyxora-text-light/70">
            <li>
              <Link to={localizedTo('/ciencia')} className="hover:text-vyxora-cyan-300">
                {t('nav.ciencia')}
              </Link>
            </li>
            <li>
              <Link to={localizedTo('/contato')} className="hover:text-vyxora-cyan-300">
                {t('nav.contato')}
              </Link>
            </li>
            <li>
              <a
                href="https://inovamed3d.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-vyxora-cyan-300"
              >
                {t('footer.corporateSite')}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-widest text-vyxora-cyan-300">
            {t('footer.colLegal')}
          </h4>
          <ul className="space-y-2 text-sm text-vyxora-text-light/70">
            <li>{t('footer.linkPrivacidade')}</li>
            <li>{t('footer.linkTermos')}</li>
            <li>{t('footer.linkLgpd')}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-5">
        <div className="container-site flex flex-col items-center justify-between gap-2 text-xs text-vyxora-text-light/40 md:flex-row">
          <p>{t('footer.copyright', { year })}</p>
          <p>
            {t('footer.parceriaArena')} ·{' '}
            <a
              href="https://arenasoftware.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-vyxora-cyan-300"
            >
              arenasoftware.com.br
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
